import { createContext } from 'react';
import type { ConversationViewRegistry } from '../types/conversation-view.types';

/** Shared presentation boundary for chat visibility, independent of notification policy. */
export const ConversationViewContext =
  createContext<ConversationViewRegistry | null>(null);
